import React from 'react';
import { useDropzone } from 'react-dropzone';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const DropZoneWrapper = styled.tbody`
  border: 2px solid
    ${(props) => (props.isDragActive ? '#0095FF' : 'transparent')};
`;

const BottomSpacerTD = styled.th`
  position: relative;
  height: 50vh;
  width: calc(100vw - 100px);
  display: block;
  border-top: none !important;

  @media only screen and (max-width: 768px) {
    width: calc(100vw - 60px);
  }
`;

const BottomSpacer = () => (
  <tr>
    <BottomSpacerTD />
  </tr>
);

/**
 * DropZone decorator
 *
 */
function FSObjectListDropZone({ children: renderProp, onDrop }) {
  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    //TODO: add in accept prop to limit unwanted extensions
    //accept: 'image/jpeg, image/png',
    noClick: true,
    noKeyboard: true,
  });

  return (
    <DropZoneWrapper {...getRootProps()} isDragActive={isDragActive}>
      <tr style={{ display: 'none' }}>
        <td>
          <input {...getInputProps()} />
        </td>
      </tr>
      {renderProp(isDragActive)}
      <BottomSpacer />
    </DropZoneWrapper>
  );
}

FSObjectListDropZone.propTypes = {
  children: PropTypes.func.isRequired,
  onDrop: PropTypes.func.isRequired,
};

export default FSObjectListDropZone;
